import { FC, ReactNode } from "react"
import classNames from "classnames"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import Modal from "@/components/shared/Modal"
import "./index.scss"

export interface AlertLayoutProps {
   open: boolean
   clearMode?: boolean
   headerIconName: IconProps["name"]
   headerText: string
   description: ReactNode
   informativeIcons?: ReactNode
   iconColor: IconColor
   children: ReactNode
   className: string
   isCustom?: boolean
   onClose: () => void
}

const AlertLayout: FC<AlertLayoutProps> = ({
   open,
   clearMode = false,
   headerIconName,
   headerText,
   description,
   informativeIcons,
   iconColor,
   children,
   className,
   isCustom,
   onClose,
}) => {
   return (
      <Modal
         open={open}
         handleClose={onClose}
      >
         <div className="alert-layout">
            <div className={classNames("alert-layout__informative", className)}>
               <div className="alert-layout__informative-header">
                  {isCustom && (
                     <Icon
                        name="cellCustom"
                        size="91"
                        color={iconColor}
                     />
                  )}
                  <Icon
                     name={headerIconName}
                     size="91"
                     color={iconColor}
                  />
                  <span className="alert-layout__informative-header-text">
                     {headerText}
                  </span>
               </div>
               <div className="alert-layout__informative-description">
                  {description}
               </div>
               {informativeIcons}
               {/* {variant === Alert.YELLOW ||
                  (variant === Alert.RED && (
                     <div className="alert-layout__informative-time">
                        <Icon
                           size="25"
                           name="lastRead"
                        />
                        <span>2s</span>
                     </div>
                  ))} */}
            </div>
            <div
               className={classNames("alert-layout__detail", {
                  "alert-layout__detail--centered": clearMode,
               })}
            >
               {children}
            </div>
         </div>
      </Modal>
   )
}

export default AlertLayout
